import { MapPin, Clock } from "lucide-react";
import { PageHero, Reveal, SectionHead } from "@/components/Reveal";
import { StudioIllu, WaveMark, BrowIllu } from "@/components/Illustrations";
import { ADDRESS_1, ADDRESS_2, HOURS, MAPS_EMBED } from "@/lib/site";

const GALLERY = [
  { id: "fachada", title: "La fachada", note: "Edificio Las Creces, Local 4", Illu: StudioIllu },
  { id: "interior", title: "El interior", note: "Calma desde que entras", Illu: WaveMark },
  { id: "sala", title: "La sala de trabajo", note: "Donde ocurre la precisión", Illu: BrowIllu },
];

const Studio = () => (
  <div data-testid="studio-page">
    <PageHero
      dark
      eyebrow="Mi Studio"
      lines={["Conoce el espacio", "antes de llegar."]}
      sub="Un espacio pensado para que te sientas cómoda desde que entras — en el corazón de San Sebastián de La Gomera."
    />

    <section className="bg-cream px-6 sm:px-12 lg:px-20 py-16 lg:py-28" data-testid="studio-galeria">
      <div className="grid md:grid-cols-3 gap-6">
        {GALLERY.map(({ id, title, note, Illu }, i) => (
          <Reveal key={id} delay={i * 0.12}>
            <div className="group border border-sand bg-beige p-10 lg:p-12 flex flex-col items-start min-h-[300px] hover:bg-ink transition-colors duration-500" data-testid={`studio-${id}`}>
              <Illu className="w-28 text-gold group-hover:scale-105 transition-transform duration-500" />
              <h3 className="font-serif text-2xl mt-auto pt-10 group-hover:text-cream transition-colors duration-500">{title}</h3>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink/50 group-hover:text-gold mt-2 transition-colors duration-500">
                {note}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-8">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink/50">
          Fotografías reales del espacio — próximamente
        </p>
      </Reveal>
    </section>

    <section className="bg-ink text-cream px-6 sm:px-12 lg:px-20 py-16 lg:py-28" data-testid="studio-ubicacion">
      <div className="grid lg:grid-cols-2 gap-12 items-start">
        <div>
          <SectionHead dark eyebrow="Dónde encontrarme" title={<>San Sebastián de <span className="italic text-gold">La Gomera</span></>} />
          <Reveal className="mt-8 space-y-6">
            <p className="flex gap-3 text-cream/80 leading-relaxed">
              <MapPin size={18} className="text-gold shrink-0 mt-1" />
              <span data-testid="studio-address">
                Studio de Belleza Karina Méndez
                <br />
                {ADDRESS_1}
                <br />
                {ADDRESS_2}
              </span>
            </p>
            <p className="flex gap-3 text-cream/80">
              <Clock size={18} className="text-gold shrink-0 mt-1" />
              <span data-testid="studio-hours">
                {HOURS.map(([d, h]) => (
                  <span key={d} className="block">
                    <span className="text-cream">{d}:</span> {h}
                  </span>
                ))}
              </span>
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="border border-gold/30 p-2" data-testid="studio-map">
            <iframe
              title="Mapa — Karina Méndez Studio"
              src={MAPS_EMBED}
              className="w-full h-[340px] lg:h-[420px] grayscale invert-[0.92] contrast-[0.9]"
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </section>
  </div>
);

export default Studio;
